import React, { useEffect } from "react";
function useComponentRef(outerRef) {
    const innerRef = React.useRef(null);
    useEffect(() => {
        if (innerRef.current && typeof outerRef === "function") {
            outerRef(innerRef.current);
        }
    }, [innerRef.current]);
    return outerRef != null && typeof outerRef != "function"
        ? outerRef
        : innerRef;
}
export default useComponentRef;
//# sourceMappingURL=useComponentRef.js.map